import React, { useState, createContext, useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import { Dashboard } from './pages/Dashboard';
import { DiveLog } from './pages/DiveLog';
import { DiveDetail } from './pages/DiveDetail';
import { NewDiveEntry } from './pages/NewDiveEntry';
import { Profile } from './pages/Profile';
import { Settings } from './pages/Settings';
import { Community } from './pages/Community';
import { CreatePost } from './pages/CreatePost';
import { Courses } from './pages/Courses';
import { Marketplace } from './pages/Marketplace';
import { Login } from './pages/auth/Login';
import { Register } from './pages/auth/Register';
import { Verification } from './pages/auth/Verification';
import { Landing } from './pages/Landing';
import { BottomNavigation } from './components/layout/BottomNavigation';
import { PageContainer } from './components/layout/PageContainer';
// Create an auth context
export const AuthContext = createContext(null);
export function App() {
  // Convert to state variable
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const handleLogout = () => {
    // Set isLoggedIn to false immediately to prevent any flashing
    setIsLoggedIn(false);
  };
  if (!isLoggedIn) {
    return <Router data-id="element-0">
        <Routes data-id="element-1">
          <Route path="/" element={<Landing data-id="element-3" />} data-id="element-2" />
          <Route path="/login" element={<Login data-id="element-5" />} data-id="element-4" />
          <Route path="/register" element={<Register data-id="element-7" />} data-id="element-6" />
          <Route path="/verification" element={<Verification data-id="element-9" />} data-id="element-8" />
          {/* Add catch-all route to redirect to landing page */}
          <Route path="*" element={<Landing data-id="element-11" />} data-id="element-10" />
        </Routes>
      </Router>;
  }
  return <Router data-id="element-12">
      <AuthContext.Provider value={{
      isLoggedIn,
      handleLogout
    }} data-id="element-13">
        <div className="bg-background min-h-screen text-navy" data-id="element-14">
          <PageContainer data-id="element-15">
            <Routes data-id="element-16">
              <Route path="/" element={<Dashboard data-id="element-18" />} data-id="element-17" />
              <Route path="/dives" element={<DiveLog data-id="element-20" />} data-id="element-19" />
              <Route path="/dives/new" element={<NewDiveEntry data-id="element-22" />} data-id="element-21" />
              <Route path="/dives/:id" element={<DiveDetail data-id="element-24" />} data-id="element-23" />
              <Route path="/profile" element={<Profile data-id="element-26" />} data-id="element-25" />
              <Route path="/settings" element={<Settings data-id="element-28" />} data-id="element-27" />
              <Route path="/community" element={<Community data-id="element-30" />} data-id="element-29" />
              <Route path="/community/create-post" element={<CreatePost data-id="element-32" />} data-id="element-31" />
              <Route path="/learn" element={<Courses data-id="element-34" />} data-id="element-33" />
              <Route path="/marketplace" element={<Marketplace data-id="element-36" />} data-id="element-35" />
              <Route path="/login" element={<div className="bg-background min-h-screen" data-id="element-38">
                    <Login data-id="element-39" />
                  </div>} data-id="element-37" />
              <Route path="/register" element={<div className="bg-background min-h-screen" data-id="element-41">
                    <Register data-id="element-42" />
                  </div>} data-id="element-40" />
              <Route path="/verification" element={<div className="bg-background min-h-screen" data-id="element-44">
                    <Verification data-id="element-45" />
                  </div>} data-id="element-43" />
            </Routes>
          </PageContainer>
          <Routes data-id="element-46">
            <Route path="/login" element={null} data-id="element-47" />
            <Route path="/register" element={null} data-id="element-48" />
            <Route path="/verification" element={null} data-id="element-49" />
            <Route path="/community/create-post" element={null} data-id="element-50" />
            <Route path="*" element={<BottomNavigation data-id="element-52" />} data-id="element-51" />
          </Routes>
        </div>
      </AuthContext.Provider>
    </Router>;
}